import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Text, Button, IconRocket } from "braid-design-system";
import { createContext, useContext } from "react";
import { translations } from "../../../../../../ProductSelection/components/elements/CallToAction/SelectButton/.vocab/index.mjs";
import { disabledButton } from "./SelectButton.css.mjs";
const TrackingContext = createContext({
  trackEvent: () => {
  }
});
const SelectButton = ({
  id,
  onClick,
  isSelected,
  isLoading,
  variant
}) => {
  const { t } = useTranslations(translations);
  const { trackEvent } = useContext(TrackingContext);
  const onClickAddHandler = () => {
    if (isLoading) return;
    trackEvent({
      type: "cta",
      action: isSelected ? "removed" : "added"
    });
    onClick(isSelected ? "remove" : "add");
  };
  const onClickSelectHandler = () => {
    if (isSelected || isLoading) return;
    trackEvent({ type: "cta", action: "clicked" });
    onClick("update");
  };
  const onClickCurrentHandler = () => {
    if (isSelected || isLoading) return;
    onClick("remove");
  };
  const onClickHandler = () => {
    switch (variant) {
      case "add":
        return onClickAddHandler();
      case "current":
        return onClickCurrentHandler();
      case "upgrade":
      case "select":
      default:
        return onClickSelectHandler();
    }
  };
  const content = {
    selected: t("Selected"),
    unselected: t("Select")
  };
  if (variant === "add") {
    content.selected = `— ${t("Remove")}`;
    content.unselected = t("Add");
  }
  if (variant === "upgrade") {
    content.selected = t("Selected");
    content.unselected = t("Upgrade");
  }
  if (variant === "current") {
    content.selected = "Current ad";
    content.unselected = "Current ad";
  }
  if (variant === "current" && isSelected) {
    return /* @__PURE__ */ jsx(Box, { className: disabledButton, background: "neutralLight", children: /* @__PURE__ */ jsx(Text, { weight: "strong", size: "standard", children: content.selected }) });
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      id,
      onClick: onClickHandler,
      variant: isSelected ? "solid" : "ghost",
      icon: variant === "upgrade" ? /* @__PURE__ */ jsx(IconRocket, {}) : void 0,
      iconPosition: variant === "upgrade" ? "trailing" : void 0,
      tone: "formAccent",
      loading: isLoading,
      data: { testid: `select-${id}` },
      children: isSelected ? content.selected : content.unselected
    }
  );
};
export {
  SelectButton,
  TrackingContext
};
